import { ReactNode, useEffect, useRef, useState } from 'react'

import clsx from 'clsx'

import { useIntersectionObserver } from './utils'

type Props = {
	className?: string
	target?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
	targetId?: string
	title?: string
	slot?: ReactNode
	dataTestId?: string
}

export function TableOfContents({
	className,
	slot,
	title,
	targetId = 'article-content',
	target = 'h2',
	dataTestId = 'table-of-contents'
}: Props) {
	const [activeId, setActiveId] = useState<string>()
	const [headings, setHeadings] = useState<HTMLElement[]>()
	const headingsMounted = useRef(false)

	useIntersectionObserver({ setActiveId, target, targetId })

	useEffect(() => {
		const getHeadings = async () => {
			setTimeout(() => {
				const container = document.querySelectorAll(`#${targetId} ${target}`)
				if (container.length) {
					headingsMounted.current = true
					return setHeadings(() => Array.from(container) as HTMLElement[])
				}
				return getHeadings()
			}, 50)
		}

		if (headingsMounted.current === false) {
			getHeadings()
		}
	}, [target, targetId])

	return (
		<div className={clsx(className, 'w-full self-stretch')} data-testid={dataTestId}>
			<div className="sticky top-[150px] h-max min-h-[200px] ">
				{Boolean(headings?.length) && (
					<div className="grid grid-flow-row gap-2">
						<h6 className="text-eyebrow mb-5 uppercase">{title}</h6>
						<ul className="space-y-5">
							{headings?.map((heading) => {
								return (
									<li key={heading.id}>
										<a
											className={clsx(
												'text-base text-gray-600 hover:border-b-2 border-bc-blue',
												heading.id === activeId && 'text-gray-100 font-bold border-b-2'
											)}
											data-testid={heading.id === activeId ? 'table_contents_active' : undefined}
											href={`#${heading.id}`}
											onClick={(e) => {
												e.preventDefault()
												window.location.hash = heading.id
											}}
										>
											{heading.innerText}
										</a>
									</li>
								)
							})}
						</ul>
					</div>
				)}
				{slot}
			</div>
		</div>
	)
}
